import React, { useState } from 'react';
import '../../../../assets/css/admin/dashboardCSS/NGOlist.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import { Button, Col, Card, Form, InputGroup, Row, Modal, Badge } from 'react-bootstrap';
import { Download, Eye, Filter, Search, ToggleLeft, ToggleRight } from 'lucide-react';
import TitleBar from '../../../../subscreens/admin/TitleBar';

const NGOlist = () => {
  const [searchQuery, setSearchQuery]         = useState('');
  const [filterStatus, setFilterStatus]       = useState('All');
  const [currentPage, setCurrentPage]         = useState(1);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedNgo, setSelectedNgo]         = useState(null);

  const [ngoData, setNgoData] = useState([
    {
      id: 1,
      name: 'Helping Hands',
      contactPerson: 'Ali Raza',
      email: 'info@hh.org',
      phone: '+92 300 1234567',
      location: 'Lahore, Pakistan',
      type: 'Education / Relief',
      yearEstablished: '2015',
      registrationNumber: 'REG-2015-PKR-001',
      website: 'www.helpinghands.org',
      status: 'Active',
      verificationStatus: 'Verified',
      totalCampaigns: 12,
      totalDonationsReceived: 'PKR 2,50,000',
      studentsSupported: 85,
    },
    {
      id: 2,
      name: 'EduCare NGO',
      contactPerson: 'Sara Khan',
      email: 'contact@edu.org',
      phone: '+92 321 9876543',
      location: 'Karachi, Pakistan',
      type: 'Education',
      yearEstablished: '2018',
      registrationNumber: 'REG-2018-PKR-042',
      website: 'www.educare.org',
      status: 'Active',
      verificationStatus: 'Pending',
      totalCampaigns: 7,
      totalDonationsReceived: 'PKR 1,20,000',
      studentsSupported: 40,
    },
    {
      id: 3,
      name: 'Bright Future',
      contactPerson: 'Ahmed Ali',
      email: 'bf@gmail.com',
      phone: '+92 333 5556677',
      location: 'Islamabad, Pakistan',
      type: 'Health / Education',
      yearEstablished: '2020',
      registrationNumber: 'REG-2020-PKR-089',
      website: 'www.brightfuture.pk',
      status: 'Inactive',
      verificationStatus: 'Rejected',
      totalCampaigns: 3,
      totalDonationsReceived: 'PKR 45,000',
      studentsSupported: 15,
    },
  ]);

  const totalPages = 2;

  /* ── Filtered data ── */
  const filteredData = ngoData.filter((ngo) => {
    const matchSearch =
      ngo.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      ngo.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      ngo.contactPerson.toLowerCase().includes(searchQuery.toLowerCase());
    const matchStatus = filterStatus === 'All' || ngo.status === filterStatus;
    return matchSearch && matchStatus;
  });

  /* ── Handlers ── */
  const handleView = (ngo) => {
    setSelectedNgo(ngo);
    setShowDetailModal(true);
  };

  // ✅ Toggle Active/Inactive Status
  const handleToggleStatus = (ngoId) => {
    setNgoData(prev => prev.map(ngo =>
      ngo.id === ngoId
        ? { ...ngo, status: ngo.status === 'Active' ? 'Inactive' : 'Active' }
        : ngo
    ));
  };

  const handleExport = () => {
    alert('CSV export started!');
  };

  const handlePrevPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
  const handleNextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };

  /* ── Verification badge ── */
  const VerifBadge = ({ status }) => {
    const map = {
      Verified: 'ngl-verif-verified',
      Pending:  'ngl-verif-pending',
      Rejected: 'ngl-verif-rejected',
    };
    return <span className={`ngl-verif-chip ${map[status] || map.Pending}`}>{status}</span>;
  };

  return (
    <Adminlayout>
      <div className="ngo-management-page">
        <div className="ngo-management-container">

          {/* Title */}
          <TitleBar
            title="NGO / Partner Management"
            subtitle="Manage NGOs and partner organizations"
          />

          {/* Search & Filter */}
          <Card className="dl-filter-card-donor mb-4">
            <Card.Body>
              <Row className="align-items-center">
                <Col lg={6} md={6} className="mb-3 mb-md-0">
                  <InputGroup>
                    <InputGroup.Text className="dl-search-icon-donor">
                      <Search size={18} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search by name, email, or contact..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="dl-search-input-donor"
                    />
                  </InputGroup>
                </Col>

                <Col lg={3} md={3} className="mb-3 mb-md-0">
                  <InputGroup>
                    <InputGroup.Text className="dl-filter-icon-donor">
                      <Filter size={18} />
                    </InputGroup.Text>
                    <Form.Select
                      value={filterStatus}
                      onChange={(e) => setFilterStatus(e.target.value)}
                      className="dl-filter-select-donor"
                    >
                      <option value="All">All Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Form.Select>
                  </InputGroup>
                </Col>

                <Col lg={3} md={3}>
                  <Button className="dl-export-donor-btn" onClick={handleExport}>
                    <Download size={18} /> Export CSV
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Table */}
          <div className="table-container">
            <table className="ngo-table">
              <thead>
                <tr>
                  <th>NGO Name</th>
                  <th>Contact Person</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? filteredData.map((ngo) => (
                  <tr key={ngo.id}>
                    <td className="ngo-name">{ngo.name}</td>
                    <td>{ngo.contactPerson}</td>
                    <td className="email-cell">{ngo.email}</td>
                    <td>
                      <span className={`status-badge ${ngo.status.toLowerCase()}`}>
                        {ngo.status}
                      </span>
                    </td>
                    <td>
                      {/* View Details Button */}
                      <button
                        onClick={() => handleView(ngo)}
                        className="view-button"
                        title="View Details"
                      >
                        <Eye size={16} />
                      </button>

                      {/* ✅ Toggle Status Button */}
                      <button
                        onClick={() => handleToggleStatus(ngo.id)}
                        className={`ngl-toggle-btn ${ngo.status === 'Active' ? 'ngl-deactivate-btn' : 'ngl-activate-btn'}`}
                        title={ngo.status === 'Active' ? 'Deactivate NGO' : 'Activate NGO'}
                      >
                        {ngo.status === 'Active' ? <ToggleRight size={16} /> : <ToggleLeft size={16} />}
                      </button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={5} className="ngl-no-results">No NGOs found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination-section">
            <button onClick={handlePrevPage} disabled={currentPage === 1} className="pagination-button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Prev
            </button>
            <span className="page-info">Page {currentPage} of {totalPages}</span>
            <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button">
              Next
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>

        </div>
      </div>

      {/* ════════════════════════════════
          NGO DETAIL MODAL
      ════════════════════════════════ */}
      <Modal
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        centered
        size="lg"
        className="ngl-modal"
      >
        {selectedNgo && (
          <>
            <Modal.Header closeButton className="ngl-modal-header">
              <Modal.Title className="ngl-modal-title">
                NGO Details — {selectedNgo.name}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="ngl-modal-body">

              {/* Top Row: name + verification */}
              <div className="ngl-detail-top">
                <div className="ngl-ngo-avatar">
                  {selectedNgo.name.charAt(0)}
                </div>
                <div className="ngl-detail-top-info">
                  <h3 className="ngl-detail-name">{selectedNgo.name}</h3>
                  <p className="ngl-detail-type">{selectedNgo.type}</p>
                  <div className="ngl-detail-chips">
                    <span className={`status-badge ${selectedNgo.status.toLowerCase()}`}>
                      {selectedNgo.status}
                    </span>
                    <VerifBadge status={selectedNgo.verificationStatus} />
                  </div>
                </div>
              </div>

              {/* Stats Row */}
              <div className="ngl-stats-row">
                <div className="ngl-stat-box">
                  <span className="ngl-stat-value">{selectedNgo.totalCampaigns}</span>
                  <span className="ngl-stat-label">Campaigns</span>
                </div>
                <div className="ngl-stat-box">
                  <span className="ngl-stat-value">{selectedNgo.studentsSupported}</span>
                  <span className="ngl-stat-label">Students Supported</span>
                </div>
                <div className="ngl-stat-box">
                  <span className="ngl-stat-value">{selectedNgo.totalDonationsReceived}</span>
                  <span className="ngl-stat-label">Donations Received</span>
                </div>
              </div>

              {/* Detail Grid */}
              <div className="ngl-detail-grid">
                {[
                  ['Contact Person',      selectedNgo.contactPerson],
                  ['Email',               selectedNgo.email],
                  ['Phone',               selectedNgo.phone],
                  ['Location',            selectedNgo.location],
                  ['Year Established',    selectedNgo.yearEstablished],
                  ['Registration No.',    selectedNgo.registrationNumber],
                  ['Website',             selectedNgo.website],
                  ['Verification Status', selectedNgo.verificationStatus],
                ].map(([label, value]) => (
                  <div className="ngl-detail-field" key={label}>
                    <span className="ngl-detail-label">{label}</span>
                    <span className="ngl-detail-value">{value}</span>
                  </div>
                ))}
              </div>

            </Modal.Body>

            <Modal.Footer className="ngl-modal-footer">
              <button className="ngl-btn-close" onClick={() => setShowDetailModal(false)}>
                Close
              </button>
            </Modal.Footer>
          </>
        )}
      </Modal>

    </Adminlayout>
  );
};

export default NGOlist;